import React, { FunctionComponent, useRef } from 'react';
import { isNil, replace } from 'ramda';
import { Grid, Header } from 'semantic-ui-react';
import withStyles from 'react-jss';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';
import DownloadWidget from 'components/DownloadWidget';
import { BatchData, Format } from 'components/DownloadWidget/DownloadWidget';
import { BatchConfigSegmentedData } from 'scenes/Report/scenes/BatchReport/BatchReport.config';

import styles from './ReportBase.styles';
import { FormattedDateProps } from './components/ParamsHeader/ParamsHeader';
import ParamsHeader, { ReportParams } from './components/ParamsHeader';

type Props = {
  header: string;
  params: ReportParams;
  classes: ClassProp<ReturnType<typeof styles>>;
  children: JSX.Element;

  batchKey?: string;
  title?: string | JSX.Element;
  format?: FormattedDateProps;
  noMargin?: boolean;
  batchData?: BatchData;
  downloadHeader?: JSX.Element;
  downloadOptions?: Format[];
  downloadData?: Record<string, unknown>[];
  segmentedBatchData?: BatchConfigSegmentedData;
};

const getReportName = replace(/ /g, '');

const renderTitle = (classes: any, title?: string | JSX.Element) => (
  <Grid.Row className={classes.noPadding} centered>
    <Grid.Column textAlign="center" width={16}>
      <Header className={classes.title} as="h3">
        {title}
      </Header>
    </Grid.Column>
  </Grid.Row>
);

const ReportBase: FunctionComponent<Props> = ({
  classes,
  header,
  params,
  title,
  children,
  format,
  batchKey,
  noMargin = false,
  batchData,
  downloadHeader,
  downloadOptions = ['PNG', 'PDF'],
  downloadData,
  segmentedBatchData,
}) => {
  const contentRef = useRef(null);
  return (
    <>
      <Header as="h3" className={classes.mainHeader}>
        {header}
      </Header>

      <Grid className={classes.grid}>
        <Grid.Row className={classes.noPadding} centered textAlign="center">
          {!isNil(title) && renderTitle(classes, title)}
        </Grid.Row>

        <Grid.Row>
          <ParamsHeader formattedDateProps={format} reportParams={params} />
        </Grid.Row>

        {!!batchKey && (
          <DownloadWidget
            nodeRef={contentRef}
            options={downloadOptions}
            imageName={`${params.merchantName}-${getReportName(header)}`}
            batchKey={batchKey}
            batchData={batchData}
            data={downloadData}
            header={downloadHeader}
            segmentedBatchData={segmentedBatchData}
          />
        )}

        <div ref={contentRef} className={classes.ref}>
          <Grid
            container
            className={classnames({
              [classes.childrenBlock]: !noMargin,
            })}
          >
            {children}
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default withStyles(styles)(ReportBase);
